import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { useAtomValue } from "jotai";

import { App } from "../App";
import { tokenAtom } from "../atoms/accountAtom";

import { LoginPage } from "pages/LoginPage";
import { HomePage } from "pages/HomePage";
import { MainPage } from "pages/MainPage";
import { EmployeesPage } from "pages/EmployeesPage";
import { ClientsPage } from "pages/ClientsPage";
import { ExpensesPage } from "pages/ExpensesPage";
import { PricesPage } from "pages/PricesPage";
import { StocksPage } from "pages/StocksPage";
import { StationsPage } from "pages/StationsPage";
import { PrintTemplatesPage } from "pages/PrintTemplatesPage";
import { ChequePrintTemplatesPage } from "pages/ChequePrintTemplatesPage";
import { DocumentPage } from "pages/DocumentPage";
import { MovementReportPage, ProfitReportPage } from "pages/Reports";
import { DiscountsPage } from "pages/DiscountsPage";
import { PromotionsPage } from "pages/PromotionsPage";
import { SettingsPage } from "pages/SettingsPage";
import { HelpPage } from "pages/HelpPage";

const PrivateRoute = ({ children }) => {
  const token = useAtomValue(tokenAtom);
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

const LoginRoute = ({ children }) => {
  const token = useAtomValue(tokenAtom);
  if (token) return <Navigate to="/" replace />;
  return children;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PrivateRoute>
        <App />
      </PrivateRoute>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "help", element: <HelpPage /> },
      {
        path: "references",
        children: [
          { path: "products", element: <MainPage /> },
          { path: "employees", element: <EmployeesPage /> },
          { path: "print-templates", element: <PrintTemplatesPage /> },
          { path: "cheque-print-templates", element: <ChequePrintTemplatesPage /> },
          { path: "clients", element: <ClientsPage /> },
          { path: "expenses", element: <ExpensesPage /> },
          { path: "prices", element: <PricesPage /> },
          { path: "stock", element: <StocksPage /> },
          { path: "stations", element: <StationsPage /> },
        ],
      },
      { path: "documents/:id", element: <DocumentPage /> },
      {
        path: "marketing",
        children: [
          { path: "discounts", element: <DiscountsPage /> },
          { path: "promotions", element: <PromotionsPage /> },
        ],
      },
      {
        path: "reports",
        children: [
          { path: "movement", element: <MovementReportPage /> },
          { path: "profit", element: <ProfitReportPage /> },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: (
      <LoginRoute>
        <LoginPage />
      </LoginRoute>
    ),
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
